<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="undefined"
    ref="gc-base-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="getScreenJson.title"
        :createModeIsEditMode="getHeaderScreenJson.title.createModeIsEditMode"
        :baseView="baseView"
        :primaryLabel="
          baseView.mode == 'create'
            ? 'Create Sales Order'
            : 'Sales Order # ' + baseView.id
        "
        :secondaryLabel="
          baseView.mode == 'review' ? model.CustomerName : undefined
        "
        v-if="loaded"
      />
    </template>
    <div v-if="loaded" class="sales-order-v4">
      <gc-header-form
        :headerOptions="getHeaderScreenJson"
        :data="loaded ? model : {}"
        :saveTransaction="saveTransaction"
        :backButtonRoute="backButtonRoute"
        ref="gc-header-form-component"
        :getHeaderToolbar="undefined"
        :setLoading="showLoading"
        v-show="!gridExpand"
      ></gc-header-form>

      <div class="gc-details-grid">
        <dx-data-grid
          :data-source="getProductEntryLocalItems"
          :columns="getProductEntryColumns"
          :height="getGridHeight"
          :column-chooser="{ enabled: false }"
          :ref="'dx-data-grid-comp'"
          :key-expr="'ID'"
          :repaintChangesOnly="true"
          :show-borders="true"
          :showRowLines="true"
          :row-alternation-enabled="true"
          :on-row-prepared="onRowPrepared"
          :two-way-binding-enabled="false"
          @editor-preparing="onEditorPreparing"
          :focusedRowEnabled="true"
          @toolbar-preparing="onToolbarPreparing($event)"
          :on-row-removed="onRowRemoved"
          @content-ready="onContentReady"
          @focused-row-changed="onFocusedRowChanged"
          @saved="onSaved"
        >
          <!-- <DxPaging :enabled="false" /> 
          :allow-deleting="baseView.mode != 'review'"-->
          <DxEditing
            :allow-updating="baseView.mode != 'review'"
            :allow-deleting="baseView.mode != 'review'"
            mode="cell"
            :new-row-position="'last'"
            :use-icons="true"
            :changes="changes"
            :select-text-on-edit-start="true"
          />

          <DxKeyboardNavigation
            :edit-on-key-press="true"
            :enter-key-action="'startEdit'"
            :enter-key-direction="'none'"
            :enabled="true"
          />

          <DxPaging :page-size="200" :enabled="false" />
          <DxPager
            :showInfo="true"
            :showPageSizeSelector="false"
            :infoText="'({2} items)'"
            :visible="false"
          />

          <template #menu-cell-template="{ data }">
            <DxDropDownButton
              :items="[
                { menuText: 'Line Comment', data: data },
                { menuText: 'Item History', data: data },
              ]"
              keyExpr="menuText"
              displayExpr="menuText"
              :drop-down-options="{ width: 250 }"
              class="gc-dropdown-icon-button"
              :id="data.data.ID"
              :icon="'overflow'"
              styling-mode="text"
              :show-arrow-icon="false"
              :onItemClick="onSoDetailsLineContextMenuItemClick"
            />
          </template>
          <template #buttons-template="{ data }">
            <div>
              <DxButton icon="add" />
              <!-- <DxButton name="delete" /> -->
            </div>
          </template>
          <!-- <DxSummary>
          <DxTotalItem
            :summary-type="'sum'"
            :value-format="'##,###,##0.00'"
            :name="'SalesUMNetFXPrice'"
            display-format="{0}"
            :show-in-column="'SalesUMNetFXPrice'"
            column="SalesUMNetFXPrice"
          />
          <DxTotalItem
            :summary-type="'sum'"
            :value-format="'##,###,##0.00'"
            :name="'TaxFXLineTotal'"
            display-format="{0}"
            :show-in-column="'TaxFXLineTotal'"
            column="TaxFXLineTotal"
          />

          <DxTotalItem
            column="TaxableFXLineTotal"
            :summary-type="'sum'"
            :value-format="'##,###,##0.00'"
            :name="'TaxableFXLineTotal'"
            display-format="{0}"
            :show-in-column="'TaxableFXLineTotal'"
          />
        </DxSummary> -->
        </dx-data-grid>
      </div>

      <GcFooter v-if="showFooter">
        <template #leftContent>
          <div
            class="gc-grid-footer-item"
            v-for="item in footerLeftItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>

            <label
              v-if="item.fieldType == 'custome-string'"
              class="gc-footer-value"
              >{{ item.value }}</label
            >
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format == 'Decimal-16-4C' ? 8 : 6"
              v-else
            />
          </div>
        </template>
        <template #rightContent>
          <div
            class="gc-grid-footer-item"
            v-for="item in footerRightItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format == 'Decimal-16-4C' ? 8 : 6"
            />
          </div>
        </template>
      </GcFooter>
    </div>

    <!-- Product Search Popup  -->
    <GcPopUpSearchForItem
      v-if="searchForItem && searchForItem.visible"
      :setVisible="searchForItem.visible"
      :callBack="searchForItem.popUpCallBack"
      :baseView="baseView"
      :setLoading="showLoading"
      :productListQuery="
        searchForItem.productListQuery
          ? searchForItem.productListQuery
          : undefined
      "
      :productListColumns="
        searchForItem.columns ? searchForItem.columns : undefined
      "
      :productListItems="
        searchForItem.productListItems
          ? searchForItem.productListItems
          : undefined
      "
      :title="'Search Product'"
      :gridOptions="{
        options: {
          pageSize: 50,
        },
      }"
    />

    <!-- Line Comment Popup  -->
    <DxPopup
      :visible.sync="lineCommentsPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :show-title="true"
      title="Line Comment"
      :width="550"
      :height="400"
      :showCloseButton="false"
    >
      <form>
        <DxForm
          :ref="'line-comments-form'"
          :customizeItem="customizeLineCommentItem"
          :form-data.sync="lineCommentModel"
          :items="lineCommentItems"
          :label-location="formsConfig.labelPosition"
        ></DxForm>
      </form>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popupLineCommentBackButtonClick"
        />
      </div>
    </DxPopup>

    <!-- items history popup  -->
    <DxPopup
      :visible.sync="itemHistoryPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Customer Item History"
      :showCloseButton="false"
      :height="700"
      @hidden="itemHistoryPopupHidden"
    >
      <dx-data-grid
        :data-source="customerItemHistoryDataSourceConfig"
        :height="540"
        :columns="customerItemHistoryColumns"
        @toolbar-preparing="itemHistoryToolbarPreparing($event)"
        ref="itemHistoryGrid"
        :allow-column-reordering="false"
        :column-chooser="{ enabled: false }"
        @content-ready="itemHistoryAddGridNoResults($event)"
      >
        <template #historyStatusTemplate="{ data }">
          <gc-status-chip :status="data.data.Status" />
        </template>

        <template #date-in-cell-template="{ data }">
          <gc-friendly-date :date="data.data.DateIn" />
        </template>

        <template #displayDescription="{ data }">
          <div class="informer">
            <GcHeaderContentDynamic
              :baseView="baseView"
              :primaryLabel="customerItemHistory['ProductDescription']"
              :secondaryLabel="customerItemHistory['ItemCode']"
              :viewMode="'popup'"
            />
          </div>
        </template>
      </dx-data-grid>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="itemHistoryPopupHidden"
        />
      </div>
    </DxPopup>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import {
  getDecimalFormat,
  // getDefaultCustomerSettings,
  getFactorByCode,
  getGlobalField,
} from "../../_store/helpers";
import { ProductService } from "../../_services/api/products/product.service";
import { CustomerDeliveryAddressService } from "../../_services/api/customers/customer-delivery-address.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { FeatureStorage } from "../../_services/storage";
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { SalesOrderV3Service } from "../../_services/api/sales/sales-order-v3.service";
import salesFormulas from "../../_helpers/formulas/sales-formulas";
import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import { SalesOrderNoteService } from "../../_services/api/sales/sales-order-note.service";
import { mapGetters } from "vuex";

import ArrayStore from "devextreme/data/array_store";
import validationEngine from "devextreme/ui/validation_engine";
import { SalesItemHistoryService } from "../../_services/api/sales/sale-item-history.service";
import DataSource from "devextreme/data/data_source";

const {
  // calculateGrossProfitPcnt,
  // calculateSalesUMPriceForGP,
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  calculateSalesUMNetFXPrice,
  calculateStockUMPrice,
  calculateStockUMNetPrice,
  calculateStockUMFXPrice,
  calculateStockUMQty,
  calculateStockUMNetFXPrice,
  calculateDiscLineTotal,
  calculateDiscFXLineTotal,
  calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
  calculateSalesUMNetPriceFromSalesUMNetFXPrice,
  calculateSalesUMPriceFromSalesUMFXPrice,
  calculateCalculatedDiscPcnt,
  // calculateSalesUMNetFXPriceFromSalesUMFXPrice,
} = salesFormulas;

function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX LOG >>> ", ...arguments);
}

let productEntryBase = {
  ProductCode: "",
  ID: 1,
  LineOrder: 0,
  IsBatchProduct: "No",
  BranchCode: undefined,
  BranchDescription: undefined,
  UnitOfMeasureCode: undefined,
  Onhand: undefined,
  AddDiscPriceGroupCode: undefined,
  AddDiscPricingMethod: undefined,
  AddDiscPricingMethodValue: undefined,
  AddDiscSalesUMPrice: undefined,
  AddDiscStockUMPrice: undefined,
  CalculatedDiscPcnt: undefined,
  Code: undefined,
  DiscFXLineTotal: 0,
  DiscLineTotal: 0,
  DiscPcnt: 0,
  ExTaxUnitCost: undefined,
  FXLineTotal: 0,
  IsCopyLine: false,
  IsNewLine: true,
  IsPrimeCostItem: false,
  ItemCode: undefined,
  ItemType: undefined,
  LineNo: 0,
  LineTotal: 0,
  NetFXLineTotal: 0,
  NetLineTotal: 0,
  PriceGroupCode: null,
  PriceGroupSalesUMPrice: 0,
  PriceGroupStockUMPrice: 0,
  PricingMethod: null,
  PricingMethodValue: 0,
  ProductDescription: undefined,
  SalesTaxPcnt: 0,
  SalesUM: undefined,
  SalesUMConversion: 0,
  SalesUMCost: 0,
  SalesUMFXPrice: 0,
  SalesUMIsVariable: false,
  SalesUMManufacturedCost: 0,
  SalesUMNetFXPrice: 0,
  SalesUMNetPrice: 0,
  SalesUMPrice: 0,
  SalesUMPromotionNetPrice: 0,
  SalesUMQty: 0,
  SalesUMStandardCost: 0,
  SalesUMStandardPrice: 0,
  StockUM: undefined,
  StockUMFXPrice: 0,
  StockUMManufacturedCost: 0,
  StockUMNetFXPrice: 0,
  StockUMNetPrice: 0,
  StockUMPrice: 0,
  StockUMQty: 0,
  StockUMStandardCost: 0,
  StockUMStandardPrice: 0,
  TaxCode: undefined,
  TaxFXLineTotal: 0,
  TaxLineTotal: 0,
  TaxableFXLineTotal: 0,
  TaxableLineTotal: 0,
  WetFXLineTotal: 0,
  WetLineTotal: 0,
  WetPcnt: 0,
  validCode: undefined,

  Comment: "",
  IsCommentVisible: false,
};
let deliveryAddressDataSourceItems = [];
var productsArray = [];

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {},
  data() {
    return {
      loaded: false,
      setLoading: false,
      ui: {
        DateAdjustedMin: null,
        DateAdjustedMax: null,
      },

      factor368ExchangeRateFieldEditable: undefined,

      model: {
        CompanyCurrency: undefined,
        Status: "N",
        CustomStatus: undefined,
        FriendlyStatus: undefined,
        Code: null,

        CustomerCode: null,
        DateIn: new Date(),
        RequiredByDate: null,
        ShipDate: null,
        OrderNo: null,

        DeliveryAddressCompanyName: null,
        DeliveryAddressCountry: null,
        DeliveryAddressPostcode: null,
        DeliveryAddressState: null,
        DeliveryAddressStreetLine1: null,
        DeliveryAddressStreetLine2: null,
        DeliveryAddressSuburb: null,
        CustomerDeliveryAddressLineNo: undefined,

        ConsignmentNo: "",
        CurrencyCode: "",
        ExchangeRate: 1,

        BranchCode: null,
        DivisionCode: null,
        SalesOrderTypeCode: null,
        SalesRepresentativeCode: null,

        SalesOrderDetails: [],

        DateChanged: null,
        DateCreated: null,
        ChangedBy: null,
        CreatedBy: null,
        Notes: [],
        LineItemCode: undefined,
      },

      productDataSourceItems: [],
      productEntryLocalItems: new ArrayStore({
        key: "ID",
        data: productsArray,
      }),

      salesUMsLocalData: [],
      editRowKey: null,
      productListItems: undefined,
      searchForItem: {},
      validationLineData: undefined,
      showFooter: true,
      footerItems: [],
      productItemsLoaded: false,

      lineCommentsPopupVisible: false,

      lineCommentModel: {
        Comment: "",
        IsCommentVisible: false,
        ID: undefined,
      },

      itemHistoryPopupVisible: false,

      customerItemHistory: [],
      changes: [],
      focusedRowData: undefined,
    };
  },

  async created() {
    this.$store.dispatch("ui/setGridExpand", false);
    productsArray = [];
    this.showLoading(true);
    this.initialized();
  },
  async mounted() {},
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
  },

  computed: {
    getProductEntryLocalItems() {
      return new DataSource({
        store: this.productEntryLocalItems,
        // reshapeOnPush: true,
        key: "ID",
      });
    },
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({ headerFormHeight: "ui/getHeaderFormHeight" }),
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    ...mapGetters({
      getValidationSummaryVisible: "ui/getValidationSummaryVisible",
    }),

    getGridHeight() {
      if (this.headerFormHeight)
        return (
          this.gridHeight -
          (this.gridExpand ? 6 : this.headerFormHeight) -
          50 -
          16
        );
      else return this.gridHeight - 50;
    },
    backButtonRoute() {
      return "/sales-order";
    },
    getScreenJson() {
      var screenJson = {
        title: "Sales Order",
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerFormVisible: true,
        deliveryAddressItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "DeliveryAddressCompanyName",
                editorType: "dxTextBox",
                label: {
                  text: "Name",
                },
                editorOptions: {
                  maxLength: "100",
                  readOnly: true,
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressStreetLine1",
                dataField: "DeliveryAddressStreetLine1",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressStreetLine2",
                dataField: "DeliveryAddressStreetLine2",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressSuburb",
                dataField: "DeliveryAddressSuburb",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressState",
                dataField: "DeliveryAddressState",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressPostcode",
                dataField: "DeliveryAddressPostcode",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressCountry",
                dataField: "DeliveryAddressCountry",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
            ],
          },
        ],
        headerToolbar: {
          audit: this.baseView.mode == "review",
          status: true,
          notes: true,
          notesItems: ["Order Comments", "Order Notes"],
          save: this.isSaveEnable,
          //   (this.baseView.mode != "edit" &&
          //     this.model.Status != "C" &&
          //     this.model.Status != "X") ||
          //   (this.baseView.mode == "edit" && this.model.Status != "C"),
          editURL: "/sales-order-v4",
          editCallBack: this.editSOCallBack,
          saveOptions: {
            items: this.baseView.id
              ? [
                  { text: "Draft", id: "D" },
                  { text: "Commit", id: "A", default: true },
                  { text: "Cancel", id: "X" },
                ]
              : [
                  { text: "Draft", id: "D" },
                  { text: "Commit", id: "A", default: true },
                ],
            keyExpr: "id",
            displayExpr: "text",
            dropDownOptions: {
              width: "100px",
            },
            saveKey: "NextStatus",
          },
          saveCallback: this.saveSalesOrder,
          screenName: "Sales Orders - All",
          pdf: this.baseView.mode == "review",

          toolbarFormItems: [
            {
              screenField: "Customer",
              dataField: "CustomerCode",
              cssClass: "toolbar-customer-label",
              editorOptions: {
                dropDownOptions: {
                  minWidth: 300,
                  elementAttr: {
                    id: "so-v4-customer-details",
                  },
                },
                width: 200,
                placeholder: "Customer Name",
                onValueChanged: this.onCustomerCodeValueChanged.bind(this),
                showClearButton: true,
                onItemClick: this.onCustomerCodeItemClicked.bind(this),
                elementAttr: {
                  id: "so-v4-customer-name",
                },
              },
              label: {
                text: "Customer",
                visible: false,
              },
              required: true,
              visible: this.baseView.mode == "create",
            },
          ],
          formContentReady: this.toolBarFormContentReady,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // // disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // disabled: true,
                  },
                },
              ],
            },
          ],
          customStatus: {
            enabled: true,
            key: "CustomStatus",
          },
          // orderComments: {
          //   dataField: "SalesOrderTypeCode",
          //   endpoint: "SalesOrderType",
          //   toMatch: [
          //     "UserComment1",
          //     "UserComment2",
          //     "UserComment3",
          //     "UserComment4",
          //     "UserComment5",
          //     "UserComment6",
          //     "UserComment7",
          //     "UserComment8",
          //     "UserComment9",
          //     "UserComment10",
          //     "UserComment11",
          //     "UserComment12",
          //     "UserComment13",
          //     "UserComment14",
          //     "UserComment15",
          //     "UserComment16",
          //     "UserComment17",
          //     "UserComment18",
          //     "UserComment19",
          //     "UserComment20",
          //   ],
          // },
          // commentItems: [
          //   {
          //     itemType: "group",
          //     caption: "",
          //     items: [],
          //   },
          // ],
        },
        title: {
          // Credit # [CreditNote] for Invoice # [InvoiceNumber]
          createModeIsEditMode: true,
          primary: {
            primary: {
              dataField: undefined,
              text:
                this.baseView.mode == "create"
                  ? "Create Sales Order"
                  : "Sales Order # " + this.baseView.id,
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
          secondary: {
            dataField:
              this.baseView.mode == "create" ? undefined : "CustomerName",
            text: undefined,
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    screenField: "DateIn",
                    label: {
                      text: "Date In",
                    },
                    dataField: "DateIn",
                    required: true,
                    editorOptions: {
                      onValueChanged: this.onDateInValueChanged.bind(this),
                    },
                  },
                  {
                    screenField: "RequiredDate",
                    label: {
                      text: "Reqd Date",
                    },
                    dataField: "RequiredByDate",
                    required: true,
                    editorOptions: {
                      onValueChanged: this.onRequiredByDateValueChanged.bind(
                        this
                      ),
                    },
                  },
                  {
                    screenField: "ShipDate",
                    label: {
                      text: "Ship Date",
                    },
                    dataField: "ShipDate",
                    required: true,
                    editorOptions: {
                      onValueChanged: this.onShipDateValueChanged.bind(this),
                    },
                  },
                  {
                    screenField: "CustPO",
                    dataField: "OrderNo",
                    editorOptions: {
                      onValueChanged: this.onOrderNoChanged.bind(this),
                    },
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    itemType: "group",
                    caption: "",
                    cssClass: "deliver-to",
                    items: [
                      {
                        screenField: "DeliverTo",
                        dataField: "DeliveryAddressCompanyName",
                        ref: "DeliveryAddressCompanyName",
                        required: true,
                        editorOptions: {
                          onItemClick: this.onDeliveryAddressChanged.bind(this),
                          // allowUpdate: true,
                        },
                        dataSourceConfig: {
                          // ingnore: true,
                          data: deliveryAddressDataSourceItems,
                        },
                        visible: this.baseView.mode != "review",
                      },
                      {
                        screenField:
                          this.baseView.mode != "review"
                            ? "DeliverTo"
                            : undefined,
                        dataField: "DeliveryAddressCompanyName",
                        ref: "DeliveryAddressCompanyName",
                        label: {
                          text: "Deliver To",
                        },
                        required: true,
                        visible: this.baseView.mode == "review",
                      },
                      {
                        screenField: "DeliveryCompanyView",
                        editAddress:
                          this.baseView.mode != "review" ? true : false,
                      },
                    ],
                  },
                  {
                    screenField: "ConNote",
                    dataField: "ConsignmentNo",
                    // required: true,
                  },
                  {
                    screenField: "CurrencyCode",
                    dataField: "CurrencyCode",
                    editorOptions: {
                      readOnly: true,
                    },
                  },
                  {
                    screenField: "ExchangeRate",
                    dataField: "ExchangeRate",
                    editorOptions: {
                      // TODO: Check the ReadOnly Logic
                      readOnly: true,
                      onValueChanged: this.onExchangeValueChanged,
                    },
                    required: true,
                    validationRules: [
                      {
                        type: "custom",

                        validationCallback: ({ value, rule }) => {
                          rule.message = `Exchange rate Cannot be 0 or Negative`;
                          return value > 0;
                        },
                      },
                    ],
                  },
                ],
              },

              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    screenField:
                      this.baseView.mode != "review" ? "Branch" : undefined,
                    label: {
                      text: "Branch",
                    },
                    dataField:
                      this.baseView.mode != "review"
                        ? "BranchCode"
                        : "Branch.Description",
                    required: true,
                    editorOptions: {
                      onValueChanged: async (e) => {
                        await this.getSalesUMs(e.value);
                        this.triggerPriceChange(e);
                      },
                    },
                  },
                  {
                    screenField:
                      this.baseView.mode != "review" ? "Division" : undefined,
                    label: {
                      text: "Division",
                    },
                    dataField:
                      this.baseView.mode != "review"
                        ? "DivisionCode"
                        : "Division.Description",
                    required: true,
                    editorOptions: {
                      onValueChanged: this.triggerPriceChange.bind(this),
                    },
                  },
                  {
                    dataField:
                      this.baseView.mode != "review"
                        ? "SalesOrderTypeCode"
                        : "SalesOrderType.Description",
                    screenField:
                      this.baseView.mode != "review" ? "OrderType" : undefined,
                    label: {
                      text: "SO Type",
                    },
                    required: true,
                    editorOptions: {
                      onValueChanged: (e) => {
                        if (e.event) this.setOrderComments(e.value);
                        this.triggerPriceChange(e);
                      },
                    },
                  },
                  {
                    screenField:
                      this.baseView.mode != "review" ? "OrderRep" : undefined,
                    dataField:
                      this.baseView.mode != "review"
                        ? "SalesRepresentativeCode"
                        : "SalesRepresentativeFullName",
                    label: {
                      text: "Sales Rep",
                    },
                    required: true,
                    // defaultValue: this.getDefaultSalesRep,
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    isSaveEnable() {
      if (this.baseView.mode == "create") return true;
      else {
        if (!this.loaded) return true;
        else if (this.model.Status == "C" || this.model.Status == "X")
          return false;
        else return true;
      }
    },
    getProductEntryColumns() {
      return [
        {
          caption: "Product",
          dataField: "ProductCode",
          showEditorAlways: this.baseView.mode != "review",
          // allowSearch: false,
          allowSorting: false,
          allowEditing: this.baseView.mode != "review",
          minWidth: 150,
          visible: this.dataViewType != "review",
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            elementAttr: {
              id: "so-v4-product-code",
            },
            onFocusIn: async () => {
              const headerToolbarForm = await validationEngine.validateGroup(
                "gc-form-header-toolbar"
              );
              if (!headerToolbarForm.isValid) {
                this.setValidationComeBack("Customer");
                this.displayValidationSummary(headerToolbarForm.brokenRules);
              }
              // else e.event.target.select();
            },
            onKeyDown: async (e, lineData) => {
              if (e.event.key == "Enter") {
                e.event.preventDefault();
                if (this.getValidationSummaryVisible) return;

                var i = this.productEntryLocalItems._array.findIndex(
                  (x) => !x.ProductCode && x.ID != lineData.data.ID
                );

                var dataGrid = this.$refs["dx-data-grid-comp"].instance;
                if (i != -1) {
                  var rowIndex = dataGrid.getRowIndexByKey(
                    this.productEntryLocalItems._array[i].ID
                  );

                  var cellElement = dataGrid.getCellElement(
                    rowIndex,
                    "ProductCode"
                  );
                  dataGrid.focus(cellElement);
                  dataGrid.editCell(rowIndex, "ProductCode");
                }
              }
            },
          },
          setCellValue: (newData, value, currentRowData) => {
            if (!value) return;
            // if (!this.model.CustomerCode) {
            //   newData.ProductCode = undefined;
            //   this.validationLineData = "Customer";
            //   this.displayValidationErrors(["Customer is required"]);
            // } else {

            var index = this.productDataSourceItems.findIndex(
              (x) => x.ItemCode == value
            );
            if (index == -1) {
              if (!this.productItemsLoaded) {
                this.showLoading(true);
                ProductService.getCustomData({
                  url: "api/ProductFilterGroupSaleItemCompanyBranch",
                  top: 1,
                  filter: `ItemCode eq '${value}' and ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
                })
                  .then((res) => {
                    this.showLoading(false);
                    if (res.data.value.length > 0) {
                      var productItem = res.data.value[0];
                      this.addItemToProductDataSource(productItem);
                      newData.ProductCode = value;
                      // var productItem = this.productDataSourceItems[index];
                      newData.ProductDescription = productItem.Description1;

                      newData.ProductDescription = productItem.Description1;
                      newData.SalesUM = productItem.SalesUM;
                      newData.ItemCode = productItem.ItemCode;
                      newData.Code = productItem.ItemCode;
                      newData.ItemType = productItem.ItemType;
                      newData.validCode = productItem.ItemCode;
                      newData.IsNewLine = false;

                      newData.ID = currentRowData.ID;
                      this.updateLocalDataSet("update", newData);

                      this.addNewRowOnBackground();

                      if (currentRowData.SalesUMQty > 0) {
                        newData.SalesUMQty = currentRowData.SalesUMQty;
                        this.getItemPriceDetails(newData, { ...newData });
                      }
                    } else {
                      if (currentRowData.validCode)
                        newData.ProductCode = currentRowData.validCode;

                      this.updateLocalDataSet("update", currentRowData);
                      this.$store.dispatch(
                        "ui/setValidationSummaryVisible",
                        true
                      );
                      this.setValidationComeBack("Product", currentRowData.ID);
                      this.displayValidationErrors([
                        "This Product does not exist. Please try again",
                      ]);
                    }
                  })
                  .catch((err) => {
                    if (err);
                    this.showLoading(false);
                  });
              } else {
                if (currentRowData.validCode)
                  newData.ProductCode = currentRowData.validCode;

                this.updateLocalDataSet("update", currentRowData);
                this.$store.dispatch("ui/setValidationSummaryVisible", true);
                this.setValidationComeBack("Product", currentRowData.ID);
                this.displayValidationErrors([
                  "This Product does not exist. Please try again",
                ]);
              }
            } else {
              newData.ProductCode = value;
              var productItem = this.productDataSourceItems[index];
              newData.ProductDescription = productItem.Description1;

              newData.ProductDescription = productItem.Description1;
              newData.SalesUM = productItem.SalesUM;
              newData.ItemCode = productItem.ItemCode;
              newData.Code = productItem.ItemCode;
              newData.ItemType = productItem.ItemType;
              newData.validCode = productItem.ItemCode;
              newData.IsNewLine = false;

              if (currentRowData.SalesUMQty > 0) {
                newData.SalesUMQty = currentRowData.SalesUMQty;
                this.getItemPriceDetails(newData, { ...newData });
              } else {
                // this.productEntryLocalItems.push([
                //   {
                //     type: "update",
                //     data: newData,
                //     key: currentRowData.ID,
                //   },
                // ]);
              }

              // this.productEntryLocalItems.update(currentRowData.ID, newData);

              this.addNewRowOnBackground();
            }
            // }
          },
          // renderAsync: true,
          fixedPosition: "left",
          fixed: true,
        },
        {
          caption: "Description",
          dataField: "ProductDescription",
          allowEditing: false,
          // renderAsync: true,
          minWidth: 220,
        },
        {
          caption: "Sales UM",
          dataField: "SalesUM",
          allowEditing: false,
          // renderAsync: true,
          width: 80,
          minWidth: 80,
        },
        {
          caption: "Quantity",
          dataField: "SalesUMQty",
          allowEditing: this.baseView.mode != "review",
          showEditorAlways: this.baseView.mode != "review",
          format: "##,###,###,###,##0.00",
          dataType: "number",
          // renderAsync: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            editorType: "dxNumberBox",
            format: "##,###,###,###,##0.00",
            // onFocusIn: (e) => {
            //   e.event.target.select();
            // },
            onKeyDown: (e) => {
              if (e.event.key == "Enter") {
                e.event.preventDefault();
                var dataGrid = this.$refs["dx-data-grid-comp"].instance;

                var i = this.productEntryLocalItems._array.findIndex(
                  (x) => !x.ProductCode
                );
                if (i != -1) {
                  var rowIndex = dataGrid.getRowIndexByKey(
                    this.productEntryLocalItems._array[i].ID
                  );

                  var cellElement = dataGrid.getCellElement(
                    rowIndex,
                    "ProductCode"
                  );
                  dataGrid.focus(cellElement);
                  dataGrid.editCell(rowIndex, "ProductCode");
                }
              }
            },
            onValueChanged: this.onSalesUMQtyValueChanged,
            step: 0,
          },
          // setCellValue: async (newData, value, currentRowData) => {
          //   console.log(
          //     "newData, value, currentRowData",
          //     newData,
          //     value,
          //     currentRowData
          //   );
          //   newData.SalesUMQty = value;
          //   newData.ID = currentRowData.ID;
          //   this.getItemPriceDetails(newData, { ...currentRowData });
          // },
          width: 100,
          minWidth: 100,
        },
        {
          caption: "Price",
          dataField: "SalesUMFXPrice",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          width: 100,
          minWidth: 100,
          // renderAsync: true,
        },
        {
          caption: "Discount",
          dataField: "DiscPcnt",
          format: "##,###,###,###,##0.00 '%'",
          allowEditing: this.baseView.mode != "review",
          showEditorAlways: this.baseView.mode != "review",
          cssClass: "edit-cell-numberbox-field",
          // renderAsync: true,
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onValueChanged: this.onDiscPcntValueChanged,
            format: "##,###,###,###,##0.00 '%'",

            // onKeyDown: this.onKeyDownCallBack,
            onKeyDown: async (e) => {
              if (e.event.key == "Enter") {
                e.event.preventDefault();
                var dataGrid = this.$refs["dx-data-grid-comp"].instance;

                var i = this.productEntryLocalItems._array.findIndex(
                  (x) => !x.ProductCode
                );
                if (i != -1) {
                  var rowIndex = dataGrid.getRowIndexByKey(
                    this.productEntryLocalItems._array[i].ID
                  );

                  var cellElement = dataGrid.getCellElement(
                    rowIndex,
                    "ProductCode"
                  );
                  dataGrid.focus(cellElement);
                  dataGrid.editCell(rowIndex, "ProductCode");
                }
              }
            },
          },
          width: 100,
          minWidth: 100,
        },
        {
          caption: "Net Price",
          dataField: "SalesUMNetFXPrice",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          width: 100,
          minWidth: 100,
          // renderAsync: true,
        },
        {
          caption: "Tax",
          dataField: "TaxFXLineTotal",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          width: 100,
          minWidth: 100,
        },
        {
          caption: "Total",
          dataField: "TaxableFXLineTotal",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          // renderAsync: true,
          width: 100,
          minWidth: 100,
        },
        {
          caption: "",
          dataField: "",
          type: "buttons",
          buttons: [
            {
              name: "add",
              icon: "add",
              onClick: (e) => {
                this.addNewRowByPosition(e);
              },
            },
            {
              name: "delete",
            },
          ],
          visible: this.baseView.mode != "review",
          width: 40,
          // cellTemplate: "buttons-template",
        },
        {
          caption: "",
          dataField: "",
          width: 30,
          minWidth: 30,
          maxWidth: 30,
          allowEditing: false,
          cellTemplate: "menu-cell-template",
          alignment: "left",
          cssClass: "more-menu",
          fixedPosition: "right",
          fixed: true,
          allowFixing: true,
          allowReordering: false,
          allowSorting: false,
          allowSearch: false,
          allowFiltering: false,
          allowGrouping: false,
        },
      ];
    },
    // Footer
    getFooterItems() {
      return [
        {
          screenField: "SalesUMItemCount",
          dataField: "SalesUMQty",
          location: "left",
          value: 0,
        },
        {
          screenField: "FXLineTotal",
          dataField: "TaxableFXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Sub Total (${this.model.CurrencyCode})`,
        },
        {
          screenField: "TaxFXTotal",
          dataField: "TaxFXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Tax (${this.model.CurrencyCode})`,
        },
        {
          screenField: "FXTotal",
          dataField: "FXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Total (${this.model.CurrencyCode})`,
        },
      ];
    },

    footerLeftItems() {
      var leftItems = this.footerItems.filter((x) => x.location == "left");

      return leftItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };
          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;
          if (c.fieldType != undefined) globalField.fieldType = c.fieldType;
          if (c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          // if(c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
    footerRightItems() {
      // return this.footerItems.filter((x) => x.location == "right");
      var rightItems = this.footerItems.filter(
        (x) =>
          x.location == "right" &&
          (x.hasOwnProperty("visible") ? x.visible : true)
      );

      return rightItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };

          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;

          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }

          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },

    // Detail Lines
    lineCommentItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "Comment",
                  editorType: "dxTextArea",
                  label: { visible: false },
                  editorOptions: {
                    height: "140",
                    maxLength: 1000,
                  },
                },
                {
                  dataField: "IsCommentVisible",
                  label: { text: "Visible On Invoice" },
                  editorType: "dxSwitch",
                },
                // {
                //   dataField: "ID",
                //   editorType: "dxNumberBox",
                //   editorOptions: {
                //     readOnly: true,
                //   },
                // },
              ],
            },
          ],
        },
      ];
    },

    customerItemHistoryDataSourceConfig() {
      if (!this.model.CustomerCode || !this.model.LineItemCode) {
        return;
      } else {
        return SalesItemHistoryService.dataSourceConfig({
          // select: ["Note", "LineNo", "SalesOrderCode"],
          sort: [{ selector: "SalesOrderCode", desc: true }],
          filter: [
            ["CustomerCode", "=", this.model.CustomerCode],
            "and",
            ["ItemType", "=", "S"],
            "and",
            ["ItemCode", "=", this.model.LineItemCode],
          ],
        });
      }
    },
    customerItemHistoryColumns() {
      return [
        {
          caption: "Order",
          dataField: "SalesOrderCode",
          alignment: "left",
          width: 130,
        },
        {
          caption: "Date",
          dataField: "DateIn",
          width: 150,
          cellTemplate: "date-in-cell-template",
          allowFiltering: false,
        },
        {
          caption: "Qty",
          dataField: "SalesUMQty",
          alignment: "right",
          format: getDecimalFormat("Decimal-16-2").ReadOnlyFormat,
          width: 150,
        },
        {
          caption: "UM",
          dataField: "SalesUM",
          alignment: "left",
          width: 100,
        },
        {
          caption: "Unit Price",
          dataField: "SalesUMNetPrice",
          alignment: "right",
          // format: this.getDecimalFormatByCode(13).Format,
          format: getDecimalFormat("Decimal-16-4C").ReadOnlyFormat,
          width: 150,
        },
        {
          caption: "Status",
          dataField: "FriendlyStatus",
          cellTemplate: "historyStatusTemplate",
          width: 100,
        },
        {
          caption: "Price Group",
          dataField: "PriceGroupDescription",
          alignment: "left",
        },
      ];
    },
  },
  methods: {
    addItemToProductDataSource(item) {
      this.productDataSourceItems.push(item);
    },
    setValidationComeBack(data, field) {
      this.validationLineData = data;
      this.validationDataField = field;
    },
    addNewRowOnBackground() {
      var maxID = Math.max(
        ...this.productEntryLocalItems._array.map((e) => e.ID)
      );
      let dataObj = Object.assign(
        { IsCopyLine: false, IsNewLine: true },
        productEntryBase
      );
      dataObj.ID = ++maxID;
      var maxLineOrder = Math.max(
        ...this.productEntryLocalItems._array.map((e) => e.LineOrder)
      );
      dataObj.LineOrder = ++maxLineOrder;

      // this.changes = [
      //   {
      //     type: "insert",
      //     data: dataObj,
      //     // insertAfterKey: e.row.key,
      //     key: dataObj.ID,
      //   },
      // ];

      this.productEntryLocalItems.insert(dataObj);
    },
    addNewRow(nextKey, params) {
      var maxID = Math.max(
        ...this.productEntryLocalItems._array.map((e) => e.ID)
      );
      let dataObj = Object.assign(
        { IsCopyLine: false, IsNewLine: true },
        productEntryBase
      );
      dataObj.ID = ++maxID;
      var maxLineOrder = Math.max(
        ...this.productEntryLocalItems._array.map((e) => e.LineOrder)
      );
      dataObj.LineOrder = ++maxLineOrder;

      this.updateLocalDataSet("insert", dataObj, nextKey, params);
    },
    async updateLocalDataSet(type, dataObj, nextKey, params) {
      if (type == "insert") {
        if (
          this.productEntryLocalItems._array.length != 0 &&
          this.productEntryLocalItems._array[
            this.productEntryLocalItems._array.length - 1
          ].Code
        ) {
          this.productEntryLocalItems.insert(dataObj);
        } else if (this.productEntryLocalItems._array.length == 0) {
          this.productEntryLocalItems.insert(dataObj);
        }
      } else if (type == "update") {
        this.productEntryLocalItems.update(dataObj.ID, dataObj);
      }

      // await this.setStockPrices(dataObj);
      // await this.setLineTotals(dataObj);

      this.setFooterItems(this.productEntryLocalItems._array);
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;

      if (type != "update") {
        setTimeout(() => {
          dataGrid
            .refresh()
            .then(() => {
              if (nextKey == "product-search") {
                this.visibleProductSearchCallBack(params.item);
              } else if (type == "insert") {
                dataGrid.navigateToRow(dataObj.ID);
                var rowIndex = dataGrid.getRowIndexByKey(dataObj.ID);
                var cellElement = dataGrid.getCellElement(
                  rowIndex,
                  "ProductCode"
                );
                dataGrid.focus(cellElement);
                dataGrid.editCell(rowIndex, "ProductCode");
              }
            })
            .catch(() => {
              dataGrid.navigateToRow(dataObj.ID);
              var rowIndex = dataGrid.getRowIndexByKey(dataObj.ID);

              if (rowIndex != -1) {
                var cellElement = dataGrid.getCellElement(
                  rowIndex,
                  "ProductCode"
                );
                dataGrid.focus(cellElement);
                dataGrid.editCell(rowIndex, "ProductCode");
              } else this.refreshDataGrid(type, dataObj, nextKey, params);
            });
        }, 250);
      } else {
        // dataGrid.saveEditData();
      }
    },
    refreshDataGrid(type, dataObj, nextKey, params) {
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      dataGrid.refresh().then(() => {
        if (nextKey == "product-search") {
          this.visibleProductSearchCallBack(params.item);
        } else if (type == "insert") {
          dataGrid.navigateToRow(dataObj.ID);
          var rowIndex = dataGrid.getRowIndexByKey(dataObj.ID);
          var cellElement = dataGrid.getCellElement(rowIndex, "ProductCode");
          dataGrid.focus(cellElement);
          dataGrid.editCell(rowIndex, "ProductCode");
        }
      });
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    toolBarFormContentReady(e) {
      if (e && this.baseView.mode != "review" && this.loaded)
        setTimeout(() => {
          var headerToolBarForm = e.component;
          if (headerToolBarForm && headerToolBarForm.getEditor("CustomerCode"))
            headerToolBarForm
              .getEditor("CustomerCode")
              .instance()
              .focus();
        }, 500);
    },

    async getItemPriceDetails(newData, currentRowData) {
      SalesOrderV3Service.setSaleItemPrice(
        // Non Grid List
        newData,
        currentRowData,
        this.model.SalesOrderTypeCode,
        this.model.BranchCode,
        this.model.CustomerCode,
        this.model.ExchangeRate,
        this.model.DateIn,
        this.model.RequiredByDate,
        false

        // eslint-disable-next-line no-unused-vars
      ).then((res) => {
        this.productEntryLocalItems.push([
          {
            type: "update",
            data: res,
            key: res.ID,
          },
        ]);

        this.setFooterItems(this.productEntryLocalItems._array);

        // this.updateLocalDataSet("update", res);
      });
    },

    setSaleItemPriceAllLines() {
      if (this.productEntryLocalItems._array.length > 0) {
        var promises = [];
        for (var i = 0; i < this.productEntryLocalItems._array.length; i++) {
          var record = this.productEntryLocalItems._array[i];
          if (record.ItemCode)
            promises.push(
              SalesOrderV3Service.setSaleItemPrice(
                // REPRICE ALL
                record,
                record,
                this.model.SalesOrderTypeCode,
                this.model.BranchCode,
                this.model.CustomerCode,
                this.model.ExchangeRate,
                this.model.DateIn,
                new Date(this.model.RequiredByDate),
                false
              )
            );
        }

        Promise.all(promises).then((data) => {
          // this.$logger.debug("All SO details line prices are set");
          // that.refreshView();
          // console.log(">>>> ", data);
          data.forEach((element) => {
            this.updateLocalDataSet("update", element);
          });
        });
      }
    },

    triggerPriceChange(e) {
      // alert("Price Change Trigger logic" , e);
      if (e.event) this.setSaleItemPriceAllLines();
    },

    async setDeliveryAddressDataSourceItems(customerCode, lineNo) {
      logDev("customerCode", customerCode);
      let deliveryAddresDs = CustomerDeliveryAddressService.dataSourceConfig(
        "api/CustomerDeliveryAddress",
        {
          select: [
            "CompanyName",
            "PhysicalAddressStreetLine1",
            "PhysicalAddressStreetLine2",
            "PhysicalAddressSuburb",
            "PhysicalAddressState",
            "PhysicalAddressPostcode",
            "PhysicalAddressCountry",
            "RecordId",
            "LineNo",
          ],
          key: "RecordId",
          filter: [
            ["Inactive", "=", "N"],
            "and",
            ["CustomerCode", "=", customerCode],
          ],
        }
      );

      let results = await deliveryAddresDs.load();

      let defaultLineNo = 1;
      if (lineNo) defaultLineNo = lineNo;
      let deliveryAddressLine1Record = results.find(
        (x) => x.LineNo == defaultLineNo
      );

      if (deliveryAddressLine1Record) {
        deliveryAddressDataSourceItems = results;
        if (this.DeliveryAddressCompanyNameEditor()) {
          this.DeliveryAddressCompanyNameEditor().beginUpdate();
          this.DeliveryAddressCompanyNameEditor().option(
            "items",
            deliveryAddressDataSourceItems
          );
          this.DeliveryAddressCompanyNameEditor().option(
            "value",
            deliveryAddressLine1Record.CompanyName
          );
          this.DeliveryAddressCompanyNameEditor().endUpdate();
        }

        if (!lineNo) {
          this.model.DeliveryAddressCompanyName =
            deliveryAddressLine1Record.CompanyName;

          this.model.DeliveryAddressCountry =
            deliveryAddressLine1Record.PhysicalAddressCountry;
          this.model.DeliveryAddressPostcode =
            deliveryAddressLine1Record.PhysicalAddressPostcode;
          this.model.DeliveryAddressState =
            deliveryAddressLine1Record.PhysicalAddressState;
          this.model.DeliveryAddressStreetLine1 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine1;
          this.model.DeliveryAddressStreetLine2 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine2;
          this.model.DeliveryAddressSuburb =
            deliveryAddressLine1Record.PhysicalAddressSuburb;
          this.model.CustomerDeliveryAddressLineNo =
            deliveryAddressLine1Record.LineNo;
        }
      }
    },

    // Start - Details Data Grid Functions
    onSaved(e) {
      if (e.changes && e.changes.length > 0) {
        var change = e.changes[0];

        if (change.insertAfterKey != undefined) {
          var element = change.data;
          var index = this.productEntryLocalItems._array.findIndex(
            (x) => x.ID == change.insertAfterKey
          );

          this.productEntryLocalItems._array.splice(
            this.productEntryLocalItems._array.length - 1,
            1
          );
          this.productEntryLocalItems._array.splice(index + 1, 0, element);
        }
      }
    },
    // onProductCodeChanged(e, lineData) {
    //   if (!e.value) return;

    //   var newData = lineData.data;

    //   var index = this.productDataSourceItems.findIndex(
    //     (x) => x.ItemCode == e.value
    //   );
    //   if (index == -1) {
    //     if (!this.productItemsLoaded) {
    //       this.showLoading(true);
    //       ProductService.getCustomData({
    //         url: "api/ProductFilterGroupSaleItemCompanyBranch",
    //         top: 1,
    //         filter: `ItemCode eq '${e.value}' and ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
    //       })
    //         .then((res) => {
    //           this.showLoading(false);
    //           if (res.data.value.length > 0) {
    //             var productItem = res.data.value[0];
    //             this.addItemToProductDataSource(productItem);
    //             newData.ProductCode = e.value;
    //             // var productItem = this.productDataSourceItems[index];
    //             newData.ProductDescription = productItem.Description1;
    //             newData.ProductDescription = productItem.Description1;
    //             newData.SalesUM = productItem.SalesUM;
    //             newData.ItemCode = productItem.ItemCode;
    //             newData.Code = productItem.ItemCode;
    //             newData.ItemType = productItem.ItemType;
    //             newData.validCode = productItem.ItemCode;
    //             newData.IsNewLine = false;
    //             // newData.ID = currentRowData.ID;
    //             this.updateLocalDataSet("update", newData);
    //             if (newData.SalesUMQty > 0) {
    //               // newData.SalesUMQty = currentRowData.SalesUMQty;
    //               this.getItemPriceDetails(newData, { ...newData });
    //             }
    //           } else {
    //             if (newData.validCode) newData.ProductCode = newData.validCode;
    //             this.updateLocalDataSet("update", newData);
    //             this.$store.dispatch("ui/setValidationSummaryVisible", true);
    //             this.setValidationComeBack("Product", newData.ID);
    //             this.displayValidationErrors([
    //               "This Product does not exist. Please try again",
    //             ]);
    //           }
    //         })
    //         .catch((err) => {
    //           if (err);
    //           this.showLoading(false);
    //         });
    //     } else {
    //       if (newData.validCode) newData.ProductCode = newData.validCode;
    //       this.updateLocalDataSet("update", newData);
    //       this.$store.dispatch("ui/setValidationSummaryVisible", true);
    //       this.setValidationComeBack("Product", newData.ID);
    //       this.displayValidationErrors([
    //         "This Product does not exist. Please try again",
    //       ]);
    //     }
    //   } else {
    //     newData.ProductCode = e.value;
    //     var productItem = this.productDataSourceItems[index];
    //     newData.ProductDescription = productItem.Description1;

    //     newData.ProductDescription = productItem.Description1;
    //     newData.SalesUM = productItem.SalesUM;
    //     newData.ItemCode = productItem.ItemCode;
    //     newData.Code = productItem.ItemCode;
    //     newData.ItemType = productItem.ItemType;
    //     newData.validCode = productItem.ItemCode;
    //     newData.IsNewLine = false;

    //     if (newData.SalesUMQty > 0) {
    //       // newData.ID = newData.ID;
    //       // newData.SalesUMQty = newData.SalesUMQty;
    //       this.getItemPriceDetails(newData, { ...newData });
    //     } else this.updateLocalDataSet("update", newData);

    //     // return newData;
    //     //               newData.ID = currentRowData.ID;
    //     // this.updateLocalDataSet("update", newData);

    //     // console.log("P 1 ", newData);

    //     this.addNewRowOnBackground();
    //   }
    //   // }
    // },
    onFocusedRowChanged(e) {
      if (e.row) this.focusedRowData = e.row.data;
      else this.focusedRowData = undefined;
    },
    addNewRowByPosition(e) {
      var maxID = Math.max(
        ...this.productEntryLocalItems._array.map((e) => e.ID)
      );
      let dataObj = Object.assign(
        { IsCopyLine: false, IsNewLine: true },
        productEntryBase
      );
      dataObj.ID = ++maxID;
      // var maxLineOrder = Math.max(
      //   ...this.productEntryLocalItems._array.map((e) => e.LineOrder)
      // );
      dataObj.LineOrder = e.row.data.LineOrder + 1;
      // dataObj.ID = e.row.data.ID + 1;

      this.changes = [
        {
          type: "insert",
          data: dataObj,
          insertAfterKey: e.row.key,
          // key: dataObj.ID,
        },
      ];

      this.productEntryLocalItems._array.forEach((element) => {
        if (element.LineOrder > e.row.data.LineOrder) {
          element.LineOrder = element.LineOrder + 1;
          // this.changes = [
          //   {
          //     type: "update",
          //     data: element,
          //     key: element.ID,
          //   },
          // ];
        }
      });
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;

      dataGrid.clearSelection();
      dataGrid.option("focusedRowIndex", -1);

      setTimeout(() => {
        dataGrid.saveEditData();
        dataGrid.refresh(true).then(() => {
          var rowIndex = dataGrid.getRowIndexByKey(dataObj.ID);
          dataGrid.navigateToRow(dataObj.ID);

          var cellElement = dataGrid.getCellElement(rowIndex, "ProductCode");
          dataGrid.focus(cellElement);
          dataGrid.editCell(rowIndex, "ProductCode");
        });
      }, 500);

      // var nextIndex = e.row.rowIndex + 1;

      // this.productEntryLocalItems.push([
      //   {
      //     type: "insert",
      //     data: dataObj,
      //     // key: dataObj.ID,
      //     index: nextIndex,
      //   },
      // ]);

      // let index = e.row.rowIndex;
      // // let max_id = Math.max(...employees.map((item) => item.ID));
      // productsArray.splice(index + 1, 0, dataObj);
      // // e.component.refresh(true);
      // // .done(() => {
      // //   e.component.editRow(index + 1);
      // // });

      // this.productEntryLocalItems = new ArrayStore({
      //   key: "ID",
      //   data: productsArray,
      // });
      // setTimeout(() => {
      //   // dataGrid.option("dataSource", this.productEntryLocalItems);
      //   dataGrid.saveEditData();
      //   dataGrid.repaint();

      //   console.log("B 2", this.productEntryLocalItems);
      // }, 1000);
    },
    onSoDetailsLineContextMenuItemClick(e) {
      if (!e.itemData.data.data.ItemCode) {
        this.setValidationComeBack("Product", e.itemData.data.data.ID);
        this.displayValidationErrors(["Product Code is required"]);
      } else {
        if (e.itemData.menuText == "Line Comment") {
          let rowData = e.itemData.data.data;

          let visibleOnInvoiceFactor = getFactorByCode(505);

          this.lineCommentModel.ID = rowData.ID;
          this.lineCommentModel.Comment = rowData.Comment;
          this.lineCommentModel.IsCommentVisible =
            rowData.LineNo == 0
              ? visibleOnInvoiceFactor.Factorc == "Y"
                ? true
                : rowData.IsCommentVisible
              : rowData.IsCommentVisible;

          this.lineCommentsPopupVisible = true;
        } else if (e.itemData.menuText == "Item History") {
          this.model.LineItemCode = e.itemData.data.data.ItemCode;
          this.customerItemHistory = e.itemData.data.data;
          this.itemHistoryPopupVisible = true;
          this.$logger.trackEventOpenPopup("Sales Order Item History");
        }
      }
    },

    customizeLineCommentItem(item) {
      if (item.itemType == "simple") {
        item.editorOptions = item.editorOptions || {};
        if (item.dataField == "Comment") {
          item.editorOptions.readOnly = this.baseView.mode == "review";
        } else {
          item.editorOptions.disabled = this.baseView.mode == "review";
        }
      }
    },

    itemHistoryPopupHidden() {
      this.model.LineItemCode = undefined;
      this.$refs["itemHistoryGrid"].instance.clearFilter("search");

      this.itemHistoryPopupVisible = false;
    },

    itemHistoryToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: "before",
        template: "displayDescription",
      });
    },

    itemHistoryAddGridNoResults(e) {
      let noDataMessageObject = {
        addNew: {
          class: undefined,
          title: "No History Lines",
          message:
            "Products despatched and invoiced to the customer will show here. Head over to the Despatch Order screen to despatch and invoice orders for this customer.",
        },
      };
      this.addGridNoResults(e, noDataMessageObject);
    },

    popupLineCommentBackButtonClick() {
      this.lineCommentsPopupVisible = false;

      this.updateLocalDataSet("update", {
        Comment: this.lineCommentModel.Comment,
        IsCommentVisible: this.lineCommentModel.IsCommentVisible,
        ID: this.lineCommentModel.ID,
      });
    },
    onContentReady() {
      setTimeout(() => {
        this.$store.dispatch(
          "ui/headerFormHeight",
          this.$refs["gc-header-form-component"].$el.clientHeight
        );
      }, 50);
    },
    onRowRemoved() {
      this.setFooterItems(this.productEntryLocalItems._array);
      if (this.productEntryLocalItems._array.length == 0) {
        let dataObj = Object.assign(
          { IsCopyLine: false, IsNewLine: true },
          productEntryBase
        );

        // dataObj.ID = index + 1;

        // this.productEntryLocalItems.push([{ type: "insert", data: dataObj }]);
        this.updateLocalDataSet("insert", dataObj);
      }
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.push({
        location: "before",
        widget: "dxButton",
        options: {
          icon: undefined,
          text: "Search",
          elementAttr: {
            class: "cx-color-button",
          },
          onClick: () => {
            this.visibleProductSearch();
          },
          visible: this.baseView.mode != "review",
        },
      });

      e.toolbarOptions.items.push({
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        // visible: !this.isTablet,
        options: {
          icon: this.gridExpand ? "collapse" : "expand",
          onClick: this.expandGrid,
          elementAttr: {
            id: "so-v4-grid-expand",
          },
        },
      });
    },
    expandGrid() {
      this.$store.dispatch("ui/setGridExpand", !this.gridExpand);
      setTimeout(() => {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;

        dataGrid.beginUpdate();
        dataGrid.updateDimensions();
        dataGrid.endUpdate();

        dataGrid.refresh(true);
      }, 500);
    },

    async visibleProductSearch() {
      const headerToolbarForm = await validationEngine.validateGroup(
        "gc-form-header-toolbar"
      );
      if (!headerToolbarForm.isValid) {
        this.validationLineData = "Customer";
        this.displayValidationSummary(headerToolbarForm.brokenRules);
      } else {
        this.searchForItem = {
          visible: true,
          popUpCallBack: this.visibleProductSearchCallBack,
          productListQuery: {
            endpoint: "ProductFilterGroupSaleItemCompanyBranch",
            // filter: `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
            select: [
              "ItemCode",
              "Description1",
              "BranchCode",
              "CustomerCode",
              "Inactive",
              "ItemType",
              "SalesUM",
              "StockUM",
            ],
            filter: [
              ["ItemType", "=", "S"],
              "and",
              ["AvailableForSale", "=", "Y"],
              "and",
              ["BranchCode", "=", `${this.model.BranchCode}`],
              "and",
              ["CustomerCode", "=", `${this.model.CustomerCode}`],
              "and",
              ["Inactive", "=", "N"],
            ],
            serverPaging: true,
            allowGrouping: false,
          },
          columns: [
            {
              screenField: "Comments",
              label: "Product",
              dataField: "ItemCode",
            },
            {
              screenField: "Comments",
              label: "Description",
              dataField: "Description1",
            },
          ],
          // productListItems: this.productListItems,
        };
      }
    },
    async visibleProductSearchCallBack(productItem, productListItems) {
      if (productListItems) this.productListItems = productListItems;
      this.searchForItem = {
        visible: false,
        popUpCallBack: this.visibleProductSearchCallBack,
        productListItems: productListItems,
      };
      if (productItem) {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;

        var dataRows = dataGrid.getVisibleRows();

        var i = dataRows.findIndex((x) => !x.data.ProductCode);
        var dataRow = undefined;

        if (i != -1) {
          dataRow = dataRows[i];
        }

        if (this.focusedRowData && this.focusedRowData.ProductCode == "")
          dataRow = { data: this.focusedRowData };

        if (dataRow) {
          if (dataRow.data.Code == undefined) {
            dataRow.data.ProductDescription = productItem.Description1;
            dataRow.data.ProductCode = productItem.ItemCode;
            dataRow.data.SalesUM = productItem.SalesUM;
            dataRow.data.ItemCode = productItem.ItemCode;
            dataRow.data.Code = productItem.ItemCode;
            dataRow.data.ItemType = productItem.ItemType;
            dataRow.data.validCode = productItem.ItemCode;
            dataRow.data.IsNewLine = false;

            this.updateLocalDataSet("update", dataRow.data, dataRow.data.ID);

            var rowIndex = dataGrid.getRowIndexByKey(dataRow.data.ID);

            var cellElement = dataGrid.getCellElement(rowIndex, "SalesUMQty");
            dataGrid.focus(cellElement);
            dataGrid.editCell(rowIndex, "SalesUMQty");

            this.addNewRowOnBackground();
          } else {
            await this.addNewRow();
            setTimeout(() => {
              this.visibleProductSearchCallBack(productItem, productListItems);
            }, 300);
          }
        } else if (dataRows.length == 0) {
          await this.addNewRow();
          setTimeout(() => {
            this.visibleProductSearchCallBack(productItem, productListItems);
          }, 300);
        }
      }
    },
    onDiscPcntValueChanged(e, lineData) {
      lineData.data.DiscPcnt = e.value;
      lineData.data.IsNewLine = false;
      let record = lineData.data;

      record.SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
        record.SalesUMFXPrice,
        record.DiscPcnt
      );
      this.setBaseCurrencyPriceFromFXPrice(record);
    },

    async setBaseCurrencyPriceFromFXPrice(record) {
      record.SalesUMPrice = calculateSalesUMPriceFromSalesUMFXPrice(
        record.SalesUMFXPrice,
        this.model.ExchangeRate
      );

      record.CalculatedDiscPcnt = calculateCalculatedDiscPcnt(
        record.SalesUMStandardPrice,
        record.SalesUMPrice
      );

      record.SalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
        record.SalesUMNetFXPrice,
        this.model.ExchangeRate
      );

      await this.setStockPrices(record);
      await this.setLineTotals(record);
      // this.productEntryLocalItems.update(record.ID, record);

      this.productEntryLocalItems.push([
        {
          type: "update",
          data: record,
          key: record.ID,
        },
      ]);

      this.setFooterItems(this.productEntryLocalItems._array);

      // this.updateLocalDataSet("update", record);
    },

    setStockPrices(record) {
      record.StockUMQty = calculateStockUMQty(
        record.SalesUMQty,
        record.SalesUMConversion
      );

      // Stock
      record.StockUMFXPrice = calculateStockUMFXPrice(
        record.SalesUMFXPrice,
        record.SalesUMConversion
      );

      record.StockUMNetFXPrice = calculateStockUMNetFXPrice(
        record.SalesUMNetFXPrice,
        record.SalesUMConversion
      );

      record.StockUMPrice = calculateStockUMPrice(
        record.SalesUMPrice,
        record.SalesUMConversion
      );

      record.StockUMNetPrice = calculateStockUMNetPrice(
        record.SalesUMNetPrice,
        record.SalesUMConversion
      );
    },
    setLineTotals(record) {
      // FX Totals
      record.DiscFXLineTotal = calculateDiscFXLineTotal(
        record.SalesUMFXPrice,
        record.SalesUMNetFXPrice,
        record.SalesUMQty
      );
      record.NetFXLineTotal = calculateNetFXLineTotal(
        record.SalesUMNetFXPrice,
        record.SalesUMQty,
        record.SalesUMFXPrice
      );
      record.WetFXLineTotal = calculateWetFXLineTotal(
        record.NetFXLineTotal,
        record.WetPcnt
      );

      record.TaxableFXLineTotal = calculateTaxableFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal
      );
      record.TaxFXLineTotal = calculateTaxFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal,
        record.SalesTaxPcnt
      );
      record.FXLineTotal = calculateFXLineTotal(
        record.TaxableFXLineTotal,
        record.TaxFXLineTotal
      );

      // Totals
      record.DiscLineTotal = calculateDiscLineTotal(
        record.DiscFXLineTotal,
        this.model.ExchangeRate
      );
      record.NetLineTotal = calculateNetLineTotal(
        record.NetFXLineTotal,
        this.model.ExchangeRate
      );
      record.WetLineTotal = calculateWetLineTotal(
        record.WetFXLineTotal,
        this.model.ExchangeRate
      );
      record.TaxableLineTotal = calculateTaxableLineTotal(
        record.TaxableFXLineTotal,
        this.model.ExchangeRate
      );
      record.TaxLineTotal = calculateTaxLineTotal(
        record.TaxFXLineTotal,
        this.model.ExchangeRate
      );
      record.LineTotal = calculateLineTotal(
        record.FXLineTotal,
        this.model.ExchangeRate
      );
      // window.ViewModel.calculateComputedFields();
    },
    onSalesUMQtyValueChanged(e, lineData) {
      lineData.data.SalesUMQty = e.value;
      lineData.data.IsNewLine = false;

      this.getItemPriceDetails(lineData.data, { ...lineData.data });
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onValueChanged) {
        let func = e.editorOptions.onValueChanged;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onValueChanged = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }
    },
    onRowPrepared() {
      // if (e.rowType == "data") {
      //   if (e.data.IsNewLine) {
      //     e.data.IsNewLine = false;
      //     var dataGrid = e.component;
      //     if (this.model.CustomerCode)
      //       setTimeout(() => {
      //         if (this.focusedRowData && !this.focusedRowData.ProductCode)
      //           return;
      //         var cellElement = dataGrid.getCellElement(
      //           e.rowIndex,
      //           "ProductCode"
      //         );
      //         dataGrid.focus(cellElement);
      //         dataGrid.editCell(e.rowIndex, "ProductCode");
      //         dataGrid.navigateToRow(e.data.ID);
      //       }, 100);
      //   }
      // }
    },
    async setProductDataSourceItems() {
      this.productDataSourceItems = [];
      var totalItemsCount = 0;
      this.setLoading = true;

      await ProductService.getCustomData({
        url: "api/ProductFilterGroupSaleItemCompanyBranch",
        count: true,
        top: 1000,
        filter: `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
      }).then((res) => {
        totalItemsCount = res.data["@odata.count"];

        this.productDataSourceItems = this.productDataSourceItems.concat(
          res.data.value
        );
        this.reCallProdcutItemsList(totalItemsCount, 1000, 1000);
      });
      this.setLoading = false;
    },
    async reCallProdcutItemsList(totalItemsCount, top, skip) {
      if (skip < totalItemsCount)
        await ProductService.getCustomData({
          url: "api/ProductFilterGroupSaleItemCompanyBranch",
          count: true,
          top: top,
          skip: skip,
          filter: `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
        }).then((res) => {
          this.productDataSourceItems = this.productDataSourceItems.concat(
            res.data.value
          );

          this.reCallProdcutItemsList(totalItemsCount, 1000, skip + 1000);
        });
      else this.productItemsLoaded = true;
    },
    // End - Details Data Grid Functions

    // Start - Header Form Functions
    HeaderFormInstance() {
      if (this.loaded)
        return this.$refs["gc-header-form-component"].$refs["gc-header-form"]
          .$refs["gc-form-comp"].instance;
    },
    DeliveryAddressCompanyNameEditor() {
      if (this.loaded) {
        return this.HeaderFormInstance().getEditor(
          "DeliveryAddressCompanyName"
        );
      }
    },
    ExchangeRateEditor() {
      return this.HeaderFormInstance().getEditor("ExchangeRate");
    },

    async onCustomerCodeValueChanged(e) {
      if (!e.value) this.model.CustomStatus = null;

      if (!e.value && e.event) {
        this.model.DeliveryAddressCompanyName = "";
        this.model.DeliveryAddressCountry = "";
        this.model.DeliveryAddressPostcode = "";
        this.model.DeliveryAddressState = "";
        this.model.DeliveryAddressStreetLine1 = "";
        this.model.DeliveryAddressStreetLine2 = "";
        this.model.DeliveryAddressSuburb = "";
        this.DeliveryAddressCompanyNameEditor().option("dataSource", []);
        return;
      }

      if (!e.event && e.value) {
        this.setDeliveryAddressDataSourceItems(e.value);
      }

      this.triggerPriceChange(e);
    },

    async onCustomerCodeItemClicked(e) {
      if (e.itemData.StopCredit == "Y") this.model.CustomStatus = "Credit Hold";
      else this.model.CustomStatus = undefined;

      let customerRecord = e.itemData;
      if (!customerRecord) {
        return;
      }

      this.showLoading(true);
      this.model.CustomerCode = customerRecord.Code;
      this.model.CurrencyCode = customerRecord.CurrencyCode;
      this.model.CustomerName = customerRecord.Name;

      this.setFooterItems(this.productEntryLocalItems._array);
      await this.setProductDataSourceItems();

      this.setExchangeRateProperties();
      await this.setDeliveryAddressDataSourceItems(this.model.CustomerCode);

      var dataGrid = this.$refs["dx-data-grid-comp"].instance;

      var i = this.productEntryLocalItems._array.findIndex(
        (x) => !x.ProductCode
      );

      if (i != -1) {
        var rowIndex = dataGrid.getRowIndexByKey(
          this.productEntryLocalItems._array[i].ID
        );

        var cellElement = dataGrid.getCellElement(rowIndex, "ProductCode");
        dataGrid.focus(cellElement);
        dataGrid.editCell(rowIndex, "ProductCode");
      }

      this.showLoading(false);
    },

    async setExchangeRateProperties() {
      let isEditable = false;

      if (
        !(
          this.baseView.mode == "review" ||
          this.factor368ExchangeRateFieldEditable == "N"
        )
      ) {
        isEditable = this.model.CompanyCurrency != this.model.CurrencyCode;
      }

      if (this.ExchangeRateEditor())
        this.ExchangeRateEditor().option("readOnly", !isEditable);

      if (this.model.CompanyCurrency != this.model.CurrencyCode) {
        let result = await CompanyCurrencyService.getByCurrencyCode(
          this.model.CurrencyCode
        );
        this.model.ExchangeRate = result.data.value[0].BuyRate;
      } else {
        this.model.ExchangeRate = 1;
      }
    },

    async onExchangeValueChanged(e) {
      if (!e.event) return;
      // if (this.isExchangeReverting) {
      //   this.isExchangeReverting = false;
      //   return;
      // }
      // if (e.value === 0) {
      //   this.displayValidationSummary([
      //     "Exchange rate should be greater than 0.0000",
      //   ]);
      //   this.isExchangeReverting = true;
      //   this.model.ExchangeRate = e.previousValue;
      // } else {
      //   this.setCompanyCurrencyPriceAllLines();
    },

    async onDeliveryAddressChanged(e) {
      this.model.CustomerDeliveryAddressLineNo = e.itemData.LineNo;
    },

    async onOrderNoChanged(e) {
      if (!e.event) return;
    },
    async onShipDateValueChanged(e) {
      if (!e.event) return;
    },
    async onRequiredByDateValueChanged(e) {
      if (!e.event) return;
      let factor565ShipDateSameAsRequiredByDate = getFactorByCode(565);

      if (factor565ShipDateSameAsRequiredByDate.Factorc == "Y") {
        this.model.ShipDate = e.value;
      }
      if (getFactorByCode(616).Factorc != "Date In") {
        this.triggerPriceChange(e);
      }
    },
    async onDateInValueChanged(e) {
      if (!e.event) return;
      if (e.event && getFactorByCode(616).Factorc == "Date In") {
        this.triggerPriceChange(e);
      }
    },
    // End - Header Form Functions

    // Start - On initialized Functions
    async initialized() {
      this.setFooterItems([]);
      if (this.baseView.mode == "create") {
        for (let index = 0; index < 5; index++) {
          let dataObj = Object.assign(
            { IsCopyLine: false, IsNewLine: true },
            productEntryBase
          );

          dataObj.ID = index + 1;
          dataObj.LineOrder = index + 1;
          // dataObj.ProductDescription = index + 1;

          this.productEntryLocalItems.insert(dataObj);
        }

        // Factors from SO-v1
        // await this.$store.dispatch(
        //   "screenFactors/getFactors",
        //   [616, 549, 550, 505, 95, 87, 565, 571, 655, 643, 368, 639, 578]
        // );

        await this.$store.dispatch("screenFactors/getFactors", [
          616,
          549,
          550,
          95,
          87,
          565,
          368,
          18,
          65,
          505,
          66,
        ]);

        await this.setDefaultSalesRep();

        this.factor368ExchangeRateFieldEditable = getFactorByCode(368);

        //  Populate defaults in the Create Mode
        this.model.DateIn = new Date();
        this.model.Status = "D";
        this.model.Code = 0;

        this.model.CompanyCode = getFactorByCode(18).Factorc;
        this.model.BranchCode = getFactorByCode(65).Factorc;
        this.model.DivisionCode = getFactorByCode(66).Factorc;

        let response = undefined;
        if (
          !this.model.CompanyCode ||
          !this.model.BranchCode ||
          !this.model.DivisionCode
        ) {
          response = await DefaultCompanyBranchDivisionService.getDefault();

          if (response.data.value.length > 0) {
            this.model.CompanyCode = response.data.value[0].CompanyCode;
            this.model.BranchCode = response.data.value[0].BranchCode;
            this.model.DivisionCode = response.data.value[0].DivisionCode;
          }
        }

        this.getSalesUMs(this.model.BranchCode);

        await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
          (res) => {
            this.model.CurrencyCode = res.data.value[0].CurrencyCode;
            this.model.CompanyCurrency = res.data.value[0].CurrencyCode;

            this.setFooterItems([]);
          }
        );

        let result = await CompanyCurrencyService.getByCurrencyCode(
          this.model.CurrencyCode
        );
        this.model.ExchangeRate = result.data.value[0].BuyRate;

        let factor549DefaultRequiredBy = getFactorByCode(549);

        if (factor549DefaultRequiredBy.Factorc == "Y") {
          let factor550RequiredByLeadDays = getFactorByCode(550);
          let requiredByLeadDays = parseInt(
            factor550RequiredByLeadDays.Factorc
          );
          let requiredByDate = new Date();
          requiredByDate.setDate(requiredByDate.getDate() + requiredByLeadDays);

          this.model.RequiredByDate = requiredByDate;

          let factor616DateForPriceGroupPriceSelection = getFactorByCode(616);
          if (factor616DateForPriceGroupPriceSelection.Factorc != "Date In") {
            this.model.FilterDate = this.model.RequiredByDate.toYYYYMMDD();
          } else {
            this.model.FilterDate = this.model.DateIn.toYYYYMMDD();
          }

          let factor565ShipDateSameAsRequiredByDate = getFactorByCode(565);

          if (factor565ShipDateSameAsRequiredByDate.Factorc == "Y") {
            this.model.ShipDate = this.model.RequiredByDate;
          } else {
            this.model.ShipDate = new Date();
          }
        }

        let factor87DefaultSalesOrderTypeCode = getFactorByCode(87);
        this.model.SalesOrderTypeCode =
          factor87DefaultSalesOrderTypeCode.Factorc;

        await this.setOrderComments(this.model.SalesOrderTypeCode);

        this.loaded = true;
        this.showLoading(false);
      } else {
        await this.$store.dispatch("screenFactors/getFactors", [505]);
        // if (this.baseView.mode == "review")
        //   this.$store.dispatch("dataContext/setDataViewType", "review");
        // else
        //   this.$store.dispatch("dataContext/setDataViewType", "product-entry");

        await SalesOrderService.getByCode(this.baseView.id)
          .then((res) => {
            if (res.data.value[0].Customer.StopCredit == "Y")
              res.data.value[0].CustomStatus = "Credit Hold";
            else res.data.value[0].CustomStatus = undefined;

            res.data.value[0].LineItemCode = undefined;

            res.data.value[0].SalesOrder = res.data.value[0].Code;
            this.model = res.data.value[0];
            this.model.CustomerDeliveryAddressLineNo = this.model.CustomerDeliveryAddressLineNo.split(
              " "
            )[0];

            this.model.CustomerName = res.data.value[0].Customer.Name;
            this.model.SalesRepresentativeFullName =
              res.data.value[0].SalesRepresentative.FirstName +
              " " +
              res.data.value[0].SalesRepresentative.Surname;
          })
          .catch((err) => {
            if (err) this.showLoading(false);
          });

        await this.setOrderComments(this.model.SalesOrderTypeCode);

        await SalesOrderNoteService.getNotesBySOCode(this.baseView.id)
          .then((res) => {
            this.model.Notes = res.data.value;
          })
          .catch((err) => {
            if (err) this.showLoading(false);
          });

        let record = await SalesOrderV3Service.getSalesOrderDetailsByCode(
          this.baseView.id
        );
        if (record && record.data.value.length > 0) {
          var data = record.data.value;
          await data.forEach(async (element, index) => {
            // this.model.Status = element.Status;
            // element.Description1 = element.ItemDescription;
            element.ItemDescription = element.Description1;
            element.Code = element.ItemCode;
            element.ProductCode = element.ItemCode;
            element.ProductDescription = element.Description1;
            element.ID = index + 1;
            element.validCode = element.ItemCode;
            element.LineOrder = index + 1;
            // this.productEntryLocalItems.push({ ...element });

            this.productEntryLocalItems.insert(element);
          });
        }

        this.setFooterItems(this.productEntryLocalItems._array);
        // await this.setProductDataSourceItems();

        this.loaded = true;
        this.showLoading(false);
      }
      // this.loaded = true;

      if (this.$refs["dx-data-grid-comp"]) {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        dataGrid.refresh(true);
      }
    },
    async editSOCallBack() {
      this.setDeliveryAddressDataSourceItems(
        this.model.CustomerCode,
        this.model.CustomerDeliveryAddressLineNo
      );
      await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
        (res) => {
          this.model.CurrencyCode = res.data.value[0].CurrencyCode;
          this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
        }
      );
      await this.setProductDataSourceItems();
    },

    async getSalesUMs(branchCode) {
      await SalesOrderV3Service.getSaleItemCompanyBranchProduct(
        branchCode
      ).then((res) => {
        this.salesUMsLocalData = res.data.value;
      });
    },

    async setDefaultSalesRep() {
      var featureItems = FeatureStorage.getItems();
      if (featureItems[0].ApplicationUserTypeCode == "Sales") {
        await SalesRepresentativeService.getUserDefaultSalesRepresentative().then(
          (res) => {
            this.model.SalesRepresentativeCode =
              res.data.value[0].SalesRepresentativeCode;
          }
        );
      } else {
        if (getFactorByCode(95).Factorc) {
          this.model.SalesRepresentativeCode = getFactorByCode(95).Factorc;
        } else {
          await CustomerService.getByCode(this.baseView.id)
            .then((res) => {
              this.model.SalesRepresentativeCode =
                res.data.value[0].SalesRepresentativeCode;
            })
            .catch((err) => {
              if (err) {
                this.model.SalesRepresentativeCode = undefined;
              }
            });
        }
      }
    },
    // End - On initialized Functions

    // Save Sales Order
    async saveTransaction(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.saveSalesOrder(this.model);
      }
    },
    async saveSalesOrder(e) {
      if (this.productEntryLocalItems.length == 0) {
        // this.addValidations(
        //   "Sales Order has no detail. Please add one or more lines before attempting to save the transaction again."
        // );

        this.displayValidationErrors([
          "Sales Order has no detail. Please add one or more lines before attempting to save the transaction again.",
        ]);
        return;
      }

      if (e.NextStatus == "X") {
        let confirmLeaving = await this.$confirm(
          "Do you really wish to cancel sales order?",
          "Cancel sales order"
        );

        if (confirmLeaving) {
          this.$logger.trackEventButtonClick("Cancel Sales Order");
          this.cancelSalesOrder();
        }
      } else {
        let payload = this.getSavePayload();

        this.showLoading(true);
        await SalesOrderV3Service.saveSalesOrder(payload, payload.Code)
          .then((res) => {
            this.showLoading(false);

            if (this.baseView.mode == "create") {
              this.model.Code = res.data.Code;
            }

            this.$notify(
              `Sales Order ${this.model.Code} Successfully Saved`,
              "success"
            );

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/sales-order`,
            });
          })
          .catch((error) => {
            this.showLoading(false);

            this.displayServerError(error, "Save Sales Order Failed");
          });
      }
    },
    async cancelSalesOrder() {
      this.setLoading = true;
      var payload = {
        Code: this.baseView.id,
      };
      await SalesOrderService.cancelSalesOrder(payload)
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.setLoading = false;
          // this.$logger.debug("result ", result);
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/sales-order`,
          });
        })
        .catch((error) => {
          this.setLoading = false;

          this.setLoading = false;
          this.displayServerError(error, "Cancel sales order Failed");
        });
    },

    getSavePayload() {
      var ExTaxTotal = 0;
      var TaxTotal = 0;
      var Total = 0;
      this.productEntryLocalItems._array.forEach((element) => {
        if (element.ItemCode && element.SalesUMQty) {
          ExTaxTotal = ExTaxTotal + element.TaxableFXLineTotal;
          TaxTotal = TaxTotal + element.TaxFXLineTotal;
          Total = Total + element.FXLineTotal;
        }
      });
      let payload = {
        BranchCode: this.model.BranchCode,
        Code: this.baseView.id ? parseInt(this.baseView.id) : 0,
        CompanyCode: this.model.CompanyCode,
        ConsignmentNo: this.model.ConsignmentNo,
        CurrencyCode: this.model.CurrencyCode,
        CustomerCode: this.model.CustomerCode,
        CustomerDeliveryAddressLineNo: this.model.CustomerDeliveryAddressLineNo.toString(),
        DateIn: new Date(this.model.DateIn).toSaveDate(),
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        Status: this.model.NextStatus,
        DivisionCode: this.model.DivisionCode,
        ExchangeRate: this.model.ExchangeRate,
        ExTaxTotal: parseFloat(ExTaxTotal.toFixed(2)),
        ItemCount: this.getSalesOrderDetailPayload().length,
        OrderNo: "",
        RequiredByDate: new Date(this.model.RequiredByDate).toSaveDate(),
        SalesOrderTypeCode: this.model.SalesOrderTypeCode,
        SalesRepresentativeCode: this.model.SalesRepresentativeCode,
        ShipDate: new Date(this.model.ShipDate).toSaveDate(),
        // Status: "A",
        TaxTotal: parseFloat(TaxTotal.toFixed(2)),
        Total: parseFloat(Total.toFixed(2)),
        UserComment1: this.model.UserComment1,
        UserComment2: this.model.UserComment2,
        UserComment3: this.model.UserComment3,
        UserComment4: this.model.UserComment4,
        UserComment5: this.model.UserComment5,
        UserComment6: this.model.UserComment6,
        UserComment7: this.model.UserComment7,
        UserComment8: this.model.UserComment8,
        UserComment9: this.model.UserComment9,
        UserComment10: this.model.UserComment10,
        UserComment11: this.model.UserComment11,
        UserComment12: this.model.UserComment12,
        UserComment13: this.model.UserComment13,
        UserComment14: this.model.UserComment14,
        UserComment15: this.model.UserComment15,
        UserComment16: this.model.UserComment16,
        UserComment17: this.model.UserComment17,
        UserComment18: this.model.UserComment18,
        UserComment19: this.model.UserComment19,
        UserComment20: this.model.UserComment20,

        SalesOrderDetails: this.getSalesOrderDetailPayload(),
        SalesOrderNotes: [],
      };

      if (this.model.Notes && this.model.Notes.length > 0) {
        let notes = this.model.Notes.map((note) => {
          let n = {
            LineNo: note.LineNo ? note.LineNo : 0,
            Note: note.Note,
          };
          return n;
        });
        payload.SalesOrderNotes = notes;
      }

      // delete payload.Status;
      // if (this.baseView.mode == "create") delete payload.Code;

      if (this.baseView.mode != "create") {
        payload.DateChanged = this.model.DateChanged;
      }
      return payload;
    },

    getSalesOrderDetailPayload() {
      let details = [];

      this.productEntryLocalItems._array.forEach((data) => {
        let detailObj = {
          SalesOrderCode: data.SalesOrderCode ? data.SalesOrderCode : 0,
          LineNo: data.LineNo ? data.LineNo : 0,
          ItemCode: data.ItemCode,
          SalesUM: data.SalesUM,
          SalesUMQty: data.SalesUMQty,
          DiscPcnt: data.DiscPcnt,
          SalesUMPrice: data.SalesUMPrice,
          Comment: data.Comment,
          IsCommentVisible: data.IsCommentVisible,
          RecordId: "00000000-0000-0000-0000-000000000000",
        };

        if (data.ItemCode && data.SalesUMQty) details.push(detailObj);
      });

      return details;
    },

    // Footer

    async setFooterItems(gridItems) {
      // this.showFooter = false;
      this.getFooterItems
        .filter((x) => (x.hasOwnProperty("visible") ? x.visible : true))
        .forEach((x) => {
          x.value = this.updateValue(x.dataField, gridItems);
          if (x.customCalc) x.value = x.customCalc(this.model, gridItems);
        });
      this.footerItems = this.getFooterItems;
      this.showFooter = true;
    },
    updateValue(dataField, items) {
      let result = 0;
      if (items.length > 0)
        items.forEach((x) => {
          if (x.CheckInclude || this.baseView.mode == "review")
            result += parseFloat(x[dataField]).roundNumber(4);
          else if (x.CheckInclude == undefined)
            result += parseFloat(x[dataField]).roundNumber(4);
        });

      return result;
    },
  },
  watch: {
    async getValidationSummaryVisible(val) {
      if (!val && this.validationLineData == "Customer") {
        if (this.gridExpand) await this.expandGrid();
        this.validationLineData = undefined;
        var headerToolBarForm = this.$refs["gc-header-form-component"].$refs[
          "gc-form-header-toolbar"
        ].$refs["toolbar-form"].$refs["gc-form-comp"].instance;
        if (headerToolBarForm) {
          headerToolBarForm.getEditor("CustomerCode").focus();
          var cusDropdown = headerToolBarForm
            .getEditor("CustomerCode")
            .instance();
          cusDropdown.open();
        }
      } else if (!val && this.validationLineData) {
        // this.focusOnGridCell(
        //   this.validationLineData.rowIndex,
        //   this.validationDataField
        //     ? this.validationDataField
        //     : this.validationLineData.column.dataField
        // );
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        var rowIndex = dataGrid.getRowIndexByKey(this.validationDataField);
        var cellElement = dataGrid.getCellElement(rowIndex, "ProductCode");
        dataGrid.focus(cellElement);
        dataGrid.editCell(rowIndex, "ProductCode");

        var index = this.productEntryLocalItems._array.findIndex(
          (x) => x.ID == this.validationDataField
        );
        if (index != -1) {
          if (this.productEntryLocalItems._array[index].validCode) {
            dataGrid.cellValue(
              rowIndex,
              "ProductCode",
              this.productEntryLocalItems._array[index].validCode
            );
          }
        }

        this.validationLineData = undefined;
        this.validationDataField = undefined;
      }
    },
  },
};
</script>

<style lang="scss">
.sales-order-v2 {
  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
    vertical-align: middle !important;
  }
}

.sales-order-v4 {
  background-color: #e1e1e9c7;
  padding-top: 10px;
  border-radius: 3px;
  .gc-header-form {
    padding: 0 10px 10px 10px;
    border-radius: inherit;
    .gc-form-header-toolbar {
      padding-bottom: 10px;
      border-radius: inherit;
    }
    .view-toolbar.form-header-toolbar {
      border-radius: inherit;
      .dx-toolbar-items-container {
        height: 45px;
        .dx-toolbar-before {
          padding-left: 1px;
        }
      }
    }
    .view-card.responsive-paddings {
      border-radius: inherit;
      margin: 0;
      // padding: 8px 12px 8px 12px !important;
    }
    .dx-form {
      .dx-texteditor-input-container {
        .dx-placeholder {
          font-size: 12px;
        }
      }
      .dx-item .dx-item-content {
        .dx-field-item-content {
          .dx-first-col {
            padding-bottom: unset;
          }
          input {
            font-size: 13px;
            padding: 7px 0 3px;
          }
        }
      }
      .dx-layout-manager {
        .dx-widget.dx-collection {
          .dx-item-content {
            // .dx-overlay-content.dx-invalid-message-content {
            //   padding: 0;
            //   transform: translate(0px, 26px) !important;
            //   font-size: 11px;
            // }
          }
        }
        .dx-field-item:not(.dx-first-row) {
          padding-top: 5px !important;
        }
      }

      .dx-invalid-message > .dx-overlay-content {
        color: #fff;
        background-color: #d9534f;
        border-radius: 4px;
        display: inline-block;
        border-width: 0;
        padding: 8px;
        font-size: 0.85em;
        line-height: normal;
        word-wrap: break-word;
      }

      .dx-invalid.dx-texteditor.dx-show-invalid-badge
        .dx-texteditor-input-container:after {
        display: block;
      }
    }

    .deliver-to {
      display: inline-flex;
      .dx-field-item-content {
        width: 100%;

        .dx-form-group
          .dx-form-group-content
          .dx-layout-manager
          .dx-widget
          > .dx-box-flex {
          flex-direction: row !important;
          > div:nth-child(1) {
            width: 100%;
          }
          > div:nth-child(2) {
            align-items: center;
            width: 50px;
            .dx-item-content {
              align-items: center;
            }
          }
        }
      }
    }
  }

  .gc-details-grid {
    border-radius: inherit;
    padding: 0 10px 10px 10px;
    .dx-widget.dx-card {
      border-radius: inherit;
      margin: 0;
    }
    .dx-datagrid {
      .dx-datagrid-header-panel {
        height: 40px;
        .dx-toolbar {
          height: inherit;
          .dx-toolbar-items-container {
            height: inherit;
            .dx-button.dx-button-has-text {
              height: 22px;
              .dx-button-content {
                padding: unset !important;
                display: flex;
                justify-content: center;
                align-content: center;
                span {
                  display: inline-flex;
                  align-items: center;
                }
              }
              .dx-button-text {
                font-size: 10px;
              }
            }

            .dx-datagrid-search-panel {
              width: 200px !important;
            }

            .dx-button.dx-button-has-icon {
              width: 30px;
              min-width: 30px;
              height: 30px;
              .dx-button-content {
                padding: 3px;
              }
              .dx-icon {
                font-size: 18px;
                margin-right: 0px;
                padding: 0px;
              }
            }
          }
        }
      }
      .dx-datagrid-headers .dx-header-row {
        td {
          padding-top: 10px;
          padding-bottom: 10px;
          padding-left: 5px;
          padding-right: 5px;
        }
      }
      .dx-datagrid-rowsview .dx-data-row {
        td {
          font-size: 12px;
          padding-top: 2px !important;
          padding-bottom: 2px !important;

          .dx-button.dx-button-has-icon {
            width: 30px;
            min-width: 30px;
            // height: 30px;
            .dx-button-content {
              padding: 3px;
            }
            .dx-icon {
              font-size: 18px;
              margin-right: 0px;
              padding: 0px;
            }
          }
        }

        .dx-editor-cell {
          input {
            font-size: 12px;
            height: 20px !important;
          }
        }
      }

      .dx-datagrid-pager {
        padding: 6px 10px;
      }

      .dx-datagrid-content .dx-datagrid-table .dx-row .dx-editor-cell {
        padding-left: 5px !important;
        padding-right: 5px !important;
      }

      .dx-row > td {
        padding-right: 5px;
        padding-left: 5px;
      }

      .dx-row-alt > td {
        background-color: #f5f5f55e;
      }

      .dx-datagrid-content
        .dx-datagrid-table
        .dx-row
        > td:first-of-type:not(.dx-command-expand) {
        padding-left: 12px !important;
      }
    }
  }
}
</style>
